<template>
  <div>
    <div class="card">
      <div class="card-header">
        <a
          class
          data-toggle="collapse"
          href="#collapseDirections"
          role="button"
          aria-expanded="false"
          aria-controls="collapseDirections"
        >
          <div class="row">
            <div class="col">
              <h3 class="card-header-title">
                <font-awesome :icon="['far', 'info-circle']" class="text-muted mr-2"/> Directions
              </h3>
            </div>

            <div class="col-auto">
              <span class="collapse-marker">
                Hide / Show
                <font-awesome :icon="['fas', 'chevron-down']"/>
              </span>
            </div>
          </div><!-- /.row -->
        </a>
      </div>

      <div class="collapse show" id="collapseDirections">
        <div class="card-body card-body-info">
          <p class="mb-0">
            Review your performance and development objectives and enter commentary below about your placement overall. You may like to include what worked well, any challenges you faced and capabilities you developed or drew on to reach your objectives.
          </p>
        </div>
      </div><!-- /.collapse -->
    </div><!-- /.card -->

    <placements-end-component-review-performance/>

    <placements-end-component-review-development/>

    <div class="decorative-divider"></div>

    <div class="alert alert-danger" v-if="errors && errors.items.length > 0">
      <p v-for="(error, index) in errors.items" :key="`error-${index}`">{{ error.msg }}</p>
    </div>

    <div class="card">
      <div class="card-header">
        <h2 class="card-header-title">Overall Placement Commentary</h2>
      </div>

      <div class="card-body">
        <label class="sr-only">Input Graduate Comments</label>
        <quill-wrapper :config="quillConfig" @change="setGraduateComments($event)" />
      </div>
    </div><!-- /.card -->

    <div class="save-actions">
      <div class="text-right">
        <ladda-button :click="discardAndExit" type="button" class="btn btn-link btn-discard mr-2">Discard &amp; Exit</ladda-button>
        <ladda-button :click="handleSaveAndExit" :validate="false" type="button" class="btn btn-outline-dark mr-2" >Save &amp; Exit</ladda-button>
        <ladda-button :click="handleSubmitForReview" :validate="true" type="button" class="btn btn-success btn-finalise-grad-end">Submit</ladda-button>
      </div>
    </div><!-- /.save-actions -->
  </div>
</template>

<script>
import { placementComputed, placementMethods } from 'vx/helpers'
import { alert } from 'utils'
import PlacementsEndComponentReviewPerformance from './PlacementsEndComponentReviewPerformance'
import PlacementsEndComponentReviewDevelopment from './PlacementsEndComponentReviewDevelopment'
export default {
  components: {
    PlacementsEndComponentReviewPerformance,
    PlacementsEndComponentReviewDevelopment
  },

  computed: {
    ...placementComputed,

    quillConfig () {
      return {
        options: { placeholder: 'Add comments...' },
        value: this.stateGraduateComments
      }
    },

    stateGraduateComments: {
      get () {
        return this.placement.end_component.graduate_comments
      },

      set (value) {
        this.setGraduateComments(value)
      }
    }
  },

  methods: {
    ...placementMethods,

    setGraduateComments (value) {
      this.setPlacementProperty({ property: 'end_component.graduate_comments', value })
    },

    async discardAndExit () {
      const confirm = await alert.confirm({
        text: 'Are you sure you want to leave? Any unsaved changes will be lost.'
      })

      if (confirm) {
        this.$router.push({ name: 'placements.single', params: { placementId: this.placement.id } })
      }
    },

    async handleSaveAndExit () {
      let payload = {
        draft: true,
        graduate_comments: this.placement.end_component.graduate_comments
      }

      await this.updateEndPlacementComponent({ graduate: this.placement.graduate_id, placement: this.placement, payload })

      this.$router.push({ name: 'placements.single', params: { placementId: this.placement.id } })
    },

    async handleSubmitForReview () {
      if (
        !await alert.confirm({
          icon: 'warning',
          title: 'Submit',
          text: 'Are you sure you want to submit your completed Performance and Development Review?'
        })
      ) {
        return
      }

      let payload = {
        draft: false,
        graduate_comments: this.placement.end_component.graduate_comments
      }

      await this.updateEndPlacementComponent({ graduate: this.placement.graduate_id, placement: this.placement, payload })

      this.$router.push({ name: 'placements.single.end.review', params: { placementId: this.placement.id } })
    }
  }
}
</script>
